import StateList from './states.list';

export const StateStores = {
  list: StateList,
};
